(() => {
  const initialize = () => {
    if (!document.body.classList.contains('mn-premium')) return;
    const targets = new Set();
    const visible = new Set();
    const whatsappTargets = new Set();
    const whatsappVisible = new Set();
    const updateVisibility = () => {
      document.body.classList.toggle('mn-floating-paused', visible.size > 0);
    };
    const updateWhatsAppVisibility = () => {
      document.body.classList.toggle('mn-whatsapp-footer-near', whatsappVisible.size > 0);
    };
    const observer = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (entry.target.isConnected && entry.isIntersecting) visible.add(entry.target);
        else visible.delete(entry.target);
      }
      updateVisibility();
    }, {rootMargin:'0px 0px 128px 0px',threshold:0}) : null;
    const whatsappObserver = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (entry.target.isConnected && entry.isIntersecting) whatsappVisible.add(entry.target);
        else whatsappVisible.delete(entry.target);
      }
      updateWhatsAppVisibility();
    }, {rootMargin:'0px 0px 28px 0px',threshold:0}) : null;
    const discover = () => {
      for (const target of targets) {
        if (target.isConnected) continue;
        observer?.unobserve(target);
        targets.delete(target);
        visible.delete(target);
      }
      for (const target of whatsappTargets) {
        if (target.isConnected) continue;
        whatsappObserver?.unobserve(target);
        whatsappTargets.delete(target);
        whatsappVisible.delete(target);
      }
      for (const target of document.querySelectorAll('.mn-footer, .mn-account-page')) {
        if (!targets.has(target)) {
          targets.add(target);
          observer?.observe(target);
        }
        if (target.matches('.mn-footer') && !whatsappTargets.has(target)) {
          whatsappTargets.add(target);
          whatsappObserver?.observe(target);
        }
      }
      updateVisibility();
      updateWhatsAppVisibility();
    };
    const label = document.body.dataset.mnWhatsappLabel;
    const enhanceWhatsApp = () => {
      const button = document.getElementById('rawa-button');
      if (!button || !label || button.dataset.mnAccessible) return Boolean(button);
      button.dataset.mnAccessible = 'true';
      button.setAttribute('role','button');
      button.setAttribute('tabindex','0');
      button.setAttribute('aria-label',label);
      button.addEventListener('keydown',(event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        if (!event.repeat) button.click();
      });
      return true;
    };
    let attempts = 0;
    let retryTimer = null;
    const retryWhatsApp = () => {
      retryTimer = null;
      if (enhanceWhatsApp() || ++attempts >= 30) return;
      retryTimer = window.setTimeout(retryWhatsApp,1000);
    };
    const refresh = () => {
      discover();
      if (retryTimer !== null) return;
      attempts = 0;
      retryWhatsApp();
    };
    refresh();
    document.addEventListener('shopify:section:load',refresh);
    document.addEventListener('shopify:section:unload',discover);
    window.addEventListener('pageshow',refresh);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initialize,{once:true});
  else initialize();
})();
